"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryselect = categoryselect;
exports.del_brand = del_brand;
exports.del_goods = del_goods;
exports.dels_category = dels_category;
exports.get_act = get_act;
exports.get_brand = get_brand;
exports.get_category = get_category;
exports.get_goods = get_goods;
exports.import_file = import_file;
exports.save_act = save_act;
exports.save_brand = save_brand;
exports.save_category = save_category;
exports.save_goods = save_goods;
var _request = _interopRequireDefault(require("@/utils/request"));
function get_brand(params) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/brand",
    method: "get",
    params: params
  });
}
function save_brand(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/brand",
    method: "post",
    data: data
  });
}
function del_brand(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/branddel",
    method: "post",
    data: data
  });
}
function categoryselect(params) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/categoryselect",
    method: "get",
    params: params
  });
}
function save_category(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/category",
    method: "post",
    data: data
  });
}
function get_category(params) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/category",
    method: "get",
    params: params
  });
}
function dels_category(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/categorydel",
    method: "post",
    data: data
  });
}
function save_act(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/activity",
    method: "post",
    data: data
  });
}
function get_act(params) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/activity",
    method: "get",
    params: params
  });
}
function get_goods(params) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/goods",
    method: "get",
    params: params
  });
}
function del_goods(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/goodsdel",
    method: "post",
    data: data
  });
}
function save_goods(data) {
  return (0, _request.default)({
    url: "/portal/system/brandpicks/goods",
    method: "post",
    data: data
  });
}
function import_file(data) {
  return (0, _request.default)({
    url: "/portal/system/file/import",
    method: "post",
    data: data
  });
}